
import React, { useEffect } from 'react'

export default function ParcelShipmentComponent({ handleDelete, libraryData, shippingTypesDetails, quoteData, handleAdd, handlePlus, handleMinus, variantLists, ProductLists, productItems, PackageType, selectedInput, handlePackage, handleFormItemChange, categoryListItems, handleChange }: any) {

    useEffect(() => {
        const input = document.getElementById("datetime") as HTMLInputElement;

        input.addEventListener("change", function () {
            const minDateTime = new Date(input.min);
            const selectedDateTime = new Date(input.value);
            if (selectedDateTime < minDateTime) {
                alert("Please select a valid time.");
                input.value = input.min; // reset to min
            }
        });

    }, []);

    return (
        <>
            <div className="w-full flex flex-col p-5 shadow rounded-xl">
                <div className="flex flex-row items-center justify-between w-full space-y-0 space-x-4">

                    {/* Shipping Option */}
                    <div className="w-full">
                        <label className="font-semibold line-clamp-2 mb-2 text-slate-800 ">
                            Shipping Option <span className="text-red-500">*</span>
                        </label>
                        <select
                            required
                            className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                            id="default"
                            onChange={(event: any) => handleChange(event.target.value, 'type')}
                            value={quoteData?.type}
                        >
                            <option>--Select--</option>
                            {libraryData?.result?.ShippingOption?.map((item: any, index: any) => (
                                <option value={item.Text} key={index}>{item.Text}</option>
                            ))}
                        </select>
                    </div>

                    {/* Schedule Date */}

                    <div className="w-full">
                        <label className="font-semibold line-clamp-2 mb-2  text-slate-800" htmlFor="date">
                            Schedule Date & Time<span className="text-red-500">*</span>
                        </label>
                        <input
                            required
                            id="datetime"
                            type="datetime-local"
                            name="scheduleDate"
                            min={new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
                                .toISOString()
                                .slice(0, 16)}
                            className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                            onChange={(event) => handleChange(event.target.value, "date")}
                            onClick={(event) => {
                                const input = event.target as HTMLInputElement;
                                input.showPicker();
                            }}

                            value={quoteData?.date || ""}

                        />
                    </div>
                </div>

            </div>
            {productItems?.map((item: any, index: any) => {
                return <div className="w-full flex flex-col  p-5 shadow rounded-xl">
                    <div className="flex flex-row items-center justify-around w-full space-x-4">


                        <div className="w-full flex justify-start items-center flex-col space-y-2 pb-5 " >
                            {PackageType?.map((item: any, index: any) => (
                                <div className="flex flex-row items-center justify-start w-full">
                                    <input
                                        name={item?.name}
                                        type="radio"
                                        placeholder=""
                                        checked={selectedInput == String(item?.name)}
                                        className={`mx-3 h-5 rounded  bg-opacity-0 `}
                                        onChange={(event: any) => {
                                            handlePackage(event),
                                                handleFormItemChange({
                                                    value: item?.name,
                                                    idx: index,
                                                    field: 'packageType'
                                                })
                                        }}
                                        value={item?.name}
                                    />
                                    <div className="font-semibold line-clamp-2 mb-2 text-slate-800">
                                        {item?.name}
                                    </div>
                                </div>
                            )
                            )}
                        </div>
                    </div>
                    <div className="flex flex-row gap-4 pb-4">
                        <div className="w-full ">
                            <label
                                className="font-semibold line-clamp-2 mb-2 text-slate-800"
                            >
                                Category <span className="text-red-500">*</span>
                            </label>

                            <select
                                required
                                className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                                id="default"
                                onChange={(event: any) => {
                                    handleFormItemChange({
                                        value: event.target.value,
                                        idx: index,
                                        field: 'CategoryId'
                                    })
                                }}
                                value={item?.CategoryId}
                            >

                                <option>--Select--</option>
                                {categoryListItems?.result?.items?.map((item: any, index: any) => (
                                    <option value={item.Id} key={index}>{item.Name}</option>
                                )
                                )}

                            </select>

                        </div>
                        <div className="w-full ">
                            <label
                                className="font-semibold line-clamp-2 mb-2 text-slate-800"
                            >
                                Product <span className="text-red-500">*</span>
                            </label>

                            <select
                                required
                                className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                                id="default"
                                onChange={(event: any) => {
                                    handleFormItemChange({
                                        value: event.target.value,
                                        idx: index,
                                        field: 'LogisticsProductId'
                                    })
                                }}
                                value={item?.LogisticsProductId}
                            >

                                <option>--Select--</option>
                                {ProductLists?.result?.items?.map((item: any, index: any) => (
                                    <option value={item.Id} key={index}>{item.Name}</option>
                                )
                                )}

                            </select>

                        </div>
                        <div className="w-full ">
                            <label
                                className="font-semibold line-clamp-2 mb-2 text-slate-800"
                            >
                                Variant <span className="text-red-500">*</span>
                            </label>

                            <select
                                required
                                className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                                id="default"
                                onChange={(event: any) => {
                                    handleFormItemChange({
                                        value: event.target.value,
                                        idx: index,
                                        field: 'LogisticsVariantId'
                                    })
                                }}
                                value={item?.LogisticsVariantId}
                            >

                                <option>--Select--</option>
                                {variantLists?.result?.items?.map((item: any, index: any) => (
                                    <option value={item.Id} key={index}>{item.Name}</option>
                                )
                                )}

                            </select>

                        </div>
                    </div>
                    <div className="grid grid-cols-3 gap-4">
                        <div className="w-full flex flex-col">
                            <label className="font-semibold line-clamp-2 mb-2 text-slate-800">
                                Dangerous
                            </label>

                            <input
                                type="checkbox"
                                name="DangerousGoods"
                                className="h-5 w-5 border border-black/50 rounded"
                                onChange={(event: any) => {
                                    handleFormItemChange({
                                        value: event.target.checked,
                                        idx: index,
                                        field: 'dangerous_goods'
                                    });
                                }}
                                checked={item?.dangerous_goods}
                            />
                        </div>



                        <div className="w-full">
                            <label
                                className="font-semibold line-clamp-2 mb-2 text-slate-800"
                            >
                                Weight <span className="text-red-500">*</span>
                            </label>

                            <input
                                required
                                type="number"
                                name="weight"
                                className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                                onChange={(event: any) => {
                                    handleFormItemChange({
                                        value: event.target.value,
                                        idx: index,
                                        field: 'weight'
                                    })
                                }}
                                value={item?.weight}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in kg
                            </span>
                        </div>
                        <div className="w-full">
                            <label
                                className="font-semibold line-clamp-2 mb-2 text-slate-800"
                            >
                                Product Value <span className="text-red-500">*</span>
                            </label>

                            <input
                                type="text"
                                name="value"
                                className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                                onChange={(event: any) => {
                                    handleFormItemChange({
                                        value: event.target.value,
                                        idx: index,
                                        field: 'value'
                                    })
                                }}
                                value={item?.value}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in ₹
                            </span>
                        </div>
                        {selectedInput == 'Custom Package' ? <div className="w-full">
                            <label
                                className="font-semibold line-clamp-2 mb-2 text-slate-800"
                            >
                                Measure
                            </label>

                            <input
                                type="number"
                                name="measure"
                                className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                                onChange={(event: any) => {
                                    handleFormItemChange({
                                        value: event.target.value,
                                        idx: index,
                                        field: 'measure'
                                    })
                                }}
                                value={item?.measure}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in mm
                            </span>
                        </div> : <div className="w-full"></div>}
                        {selectedInput == 'Custom Package' ? <div className="w-full">
                            <label
                                className="font-semibold line-clamp-2 mb-2 text-slate-800"
                            >
                                Breadth
                            </label>

                            <input
                                type="number"
                                name="breadth"
                                className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                                onChange={(event: any) => {
                                    handleFormItemChange({
                                        value: event.target.value,
                                        idx: index,
                                        field: 'breadth'
                                    })
                                }}
                                value={item?.breadth}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in mm
                            </span>
                        </div> : <div className="w-full"></div>}
                        {selectedInput == 'Custom Package' ? <div className="w-full">
                            <label
                                className="font-semibold line-clamp-2 mb-2 text-slate-800"
                            >
                                Height
                            </label>
                            <input
                                type="number"
                                name='height'
                                className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                                onChange={(event: any) => {
                                    handleFormItemChange({
                                        value: event.target.value,
                                        idx: index,
                                        field: 'Height'
                                    })
                                }}
                                value={item?.Height}
                            />
                            <span
                                className="block text-xs font-light text-right"
                            >
                                in mm
                            </span>
                        </div> : <div className="w-full"></div>}
                        {selectedInput == 'Custom Package' ? <div className="w-full">
                            <label
                                className="font-semibold line-clamp-2 mb-2 text-slate-800"
                            >
                                Length
                            </label>

                            <input
                                type="number"
                                name="length"
                                className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                                onChange={(event: any) => {
                                    handleFormItemChange({
                                        value: event.target.value,
                                        idx: index,
                                        field: 'Length'
                                    })
                                }}
                                value={item?.Length}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in mm
                            </span>
                        </div> : <div className="w-full"></div>}
                    </div>
                    <div className="flex flex-row justify-around items-end w-full">
                        <div className="w-full">
                            <label className="font-semibold line-clamp-2 mb-2 text-slate-800">Additonal Information</label>

                            <textarea
                                name={"additionainfo"}
                                placeholder=""
                                className="w-full h-20 font-normal border rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                                onChange={(event: any) => {
                                    handleFormItemChange({
                                        value: event.target.value,
                                        idx: index,
                                        field: 'item_description'
                                    })
                                }}
                                value={item?.item_description}
                            />

                        </div>
                        <div className="w-1/2 px-5 flex flex-row justify-center items-center gap-2">

                            {/* Minus Button */}
                            <svg
                                onClick={() => handleMinus(index, item?.quantity)}
                                fill="#6b7280"
                                height="18"
                                width="18"
                                className="cursor-pointer self-center mt-6"
                                viewBox="0 0 210.414 210.414"
                            >
                                <path d="M105.207,0C47.196,0,0,47.196,0,105.207c0,58.011,47.196,105.207,105.207,105.207
        c58.011,0,105.207-47.196,105.207-105.207C210.414,47.196,163.218,0,105.207,0z M105.207,202.621
        c-53.715,0-97.414-43.699-97.414-97.414c0-53.715,43.699-97.414,97.414-97.414c53.715,0,97.414,43.699,97.414,97.414
        C202.621,158.922,158.922,202.621,105.207,202.621z"/>
                                <path d="M155.862,101.31H54.552c-2.152,0-3.897,1.745-3.897,3.897c0,2.152,1.745,3.897,3.897,3.897h101.31
        c2.152,0,3.897-1.745,3.897-3.897C159.759,103.055,158.014,101.31,155.862,101.31z"/>
                            </svg>
                            <div className="w-full">
                                <label
                                    className="font-semibold line-clamp-2 mb-2 text-slate-800"
                                >
                                    Number of Items <span className="text-red-500">*</span>
                                </label>
                                <div className="border-0   text-xs " >
                                    <input
                                        required
                                        type="number"
                                        name="numberofitems"
                                        className="w-full font-normal border rounded-md px-4 py-2 text-center bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                                        onChange={(event: any) => {
                                            handleFormItemChange({
                                                value: event.target.value,
                                                idx: index,
                                                field: 'quantity'
                                            })
                                        }}
                                        value={item?.quantity}
                                    />
                                </div>
                            </div>
                            {/* Plus Button */}
                            <svg
                                onClick={() => handlePlus(index, item?.quantity)}
                                fill="#6b7280"
                                width="18"
                                height="18"
                                className="cursor-pointer self-center mt-6"
                                viewBox="0 0 32 32"
                            >
                                <path d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM23 15h-6v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v6h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h6v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6h6c0.552 0 1-0.448 1-1s-0.448-1-1-1z" />
                            </svg>
                        </div>
                        <div className="w-[100px] space-x-2 flex justify-end">
                            {(index + 1) === productItems.length ? <button onClick={() => handleAdd()} className={`bg-primary text-light px-2 text-xs py-1 rounded`}>
                                Add
                            </button> : ''}
                            {productItems.length > 1 && (index + 1) === productItems.length && (
                                <button
                                    onClick={() => handleDelete(productItems, index)}
                                    className="bg-primary text-light px-2 text-xs py-1 rounded"
                                >
                                    Delete
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            })}

        </>



    )
}